/**
 * Parses a filename from a Content-Disposition header value.
 * Returns null if no filename is found.
 *
 * Handles: attachment; filename="Entity Data Export_Feb102026.csv"
 * and: attachment; filename*=UTF-8''Entity%20Data%20Export_Feb102026.csv
 */
export function parseContentDisposition(header: string | null): string | null {
  if (!header || typeof header !== "string") {
    return null;
  }
  // Standard filename="..."
  const quotedMatch = header.match(
    /filename\s*=\s*["']?([^"';]+)["']?(?:;|$)/i,
  );
  if (quotedMatch?.[1]) {
    return quotedMatch[1].trim();
  }
  // RFC 5987 filename*=UTF-8''...
  const encodedMatch = header.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
  if (encodedMatch?.[1]) {
    try {
      return decodeURIComponent(encodedMatch[1].trim());
    } catch {
      return null;
    }
  }
  return null;
}
